import { render, staticRenderFns } from "./bulk-message-actions-menu.vue?vue&type=template&id=6750d38f&scoped=true&"
import script from "./bulk-message-actions-menu.vue?vue&type=script&lang=js&"
export * from "./bulk-message-actions-menu.vue?vue&type=script&lang=js&"
import style0 from "./bulk-message-actions-menu.vue?vue&type=style&index=0&id=6750d38f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6750d38f",
  null
  
)

export default component.exports